import {Component, OnInit} from '@angular/core';
import {PermissionsService} from '../../Services/permissions.service';
import {DataService} from '../../Services/data.service';
import {StorageService} from '../../Services/storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent implements OnInit {
// Permissions
  admin = true;
  vm: any = {};

  showSiteMap = true;
  showNavigation;
  showDashboard;
  window;

  constructor(private permissions: PermissionsService,
              private localStorage: StorageService,
              private tableDataService: DataService,
              private titleService: Title) {
    this.vm.request = {};
  }


  ngOnInit() {
    const x = this.localStorage.StorageGet('Permissions');
    this.permissions.LoadPermissions(JSON.parse(x), 'home ts');

    const tabTitle =  $localize`:accountXHome: AccountX Home `;
    this.titleService.setTitle(tabTitle);

    this.dashClick();

  }


  navClick() {
    this.AllFalse();
    this.showNavigation = true;
  }

  dashClick() {
    this.AllFalse();
    this.showDashboard = true;
  }

  AllFalse() {
    this.showNavigation = false;
    this.showDashboard = false;
  }
}
